import styled from '@emotion/styled';
import { mixins } from '@styles/mixins';
import { ThemeProps, SelectableThemeProps } from '@theme/base';
import { CountryFlag } from '@components/common/country-flag/CountryFlag';
import { Button } from '@components/material-ui';

/* ***************** *
 *       Styles      *
 * ***************** */
export const DestinationsContainer = styled.div({
  display: 'flex',
  flex: 1
});

export const FiltersColumn = styled.div(({ theme }: ThemeProps) => ({
  width: 220,
  padding: theme.custom.spacing.xLarge,
  paddingTop: 74,
  backgroundColor: theme.custom.colors.group10.lighter
}));

export const FiltersHeading = styled.h5(({ theme }: ThemeProps) => ({
  ...(theme.custom.typography.h5 as any),
  color: theme.custom.colors.group4.base,
  marginTop: 0,
  marginBottom: 61,
  ...mixins(theme).truncate
}));

export const FilterItemsWrapper = styled.ul({
  listStyle: 'none',
  padding: 0
});

export const FilterItem: any = styled.li(({ theme, isSelected }: SelectableThemeProps) => ({
  ...(theme.custom.typography.paragraph as any),
  ...(isSelected && { color: theme.custom.colors.group1.base }),
  cursor: isSelected ? 'default' : 'pointer',
  marginBottom: theme.custom.spacing.medium,

  ['&:hover']: {
    color: isSelected ? theme.custom.colors.group1.base : theme.custom.colors.group1.base
  }
}));

export const DestinationsContentContainer = styled.div(({ theme }: ThemeProps) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  paddingLeft: 95,
  paddingTop: 55,
  transition: `padding ${theme.custom.transitions.smooth}`,

  [`@media (max-width: ${theme.custom.contentSizes.maxContentWidth}px)`]: {
    paddingLeft: 55
  }
}));

export const DestinationsSortBar = styled.div(({ theme }: ThemeProps) => ({
  borderBottom: `1px solid ${theme.custom.colors.group10.light}`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingBottom: theme.custom.spacing.medium,
  marginTop: 8,

  [`@media (max-width: ${theme.custom.contentSizes.maxContentWidth}px)`]: {
    marginRight: theme.custom.spacing.medium
  }
}));

export const StyledButton = styled(Button)(({ theme }: ThemeProps) => ({
  ['.MuiButtonBase-root']: {
    borderRadius: 6,
    padding: `0 ${theme.custom.spacing.medium}px`
  }
}));

export const Sort = styled.div({
  display: 'flex'
});

export const SortHeading = styled.h5(({ theme }: ThemeProps) => ({
  ...(theme.custom.typography.h5 as any),
  ...mixins(theme).truncate,
  margin: 0
}));

export const SortOptionsContainer = styled.ul(({ theme }: ThemeProps) => ({
  listStyle: 'none',
  padding: 0,
  paddingLeft: theme.custom.spacing.large,
  display: 'flex',
  flexWrap: 'nowrap'
}));

export const SortOption: any = styled.li(({ theme, isSelected }: SelectableThemeProps) => ({
  ...(theme.custom.typography.paragraph as any),
  ...(isSelected && { color: theme.custom.colors.group1.base }),
  ...mixins(theme).truncate,
  lineHeight: '3rem',
  paddingRight: theme.custom.spacing.large,
  cursor: isSelected ? 'default' : 'pointer',

  ['&:hover']: {
    color: isSelected ? theme.custom.colors.group1.base : theme.custom.colors.group1.base
  }
}));

interface DestinationsListContainerProps extends SelectableThemeProps {
  displayInColumns: boolean;
}
export const DestinationsListContainer: any = styled.ul(
  ({ theme, displayInColumns, isSelected }: DestinationsListContainerProps) => ({
    display: isSelected ? 'block' : 'none',
    flex: 'none',
    padding: 0,
    ...(displayInColumns && { columnCount: 4 }),
    paddingTop: theme.custom.spacing.xLarge,
    paddingBottom: theme.custom.spacing.xLarge,
    listStyleType: 'none',

    [`@media (max-width: ${theme.custom.contentSizes.maxContentWidth}px)`]: {
      marginRight: theme.custom.spacing.medium
    },

    ['li']: {
      maxWidth: displayInColumns ? 'auto' : '30%'
    }
  })
);

export const AdditionalSortingLabel = styled.span(({ theme }: ThemeProps) => ({
  ...(theme.custom.typography.paragraph as any),
  color: theme.custom.colors.group4.light
}));

export const DestinationItem = styled.li(({ theme }: ThemeProps) => ({
  marginBottom: theme.custom.spacing.medium,

  ['a, a:visited']: {
    color: theme.custom.colors.group4.base,
    display: 'flex',
    alignItems: 'flex-start',
    ...(theme.custom.typography.paragraph as any),
    cursor: 'pointer'
  },

  ['&:hover']: {
    [AdditionalSortingLabel as any]: {
      color: theme.custom.colors.group1.base
    },

    [DestinationItemLabelWrapper as any]: {
      color: theme.custom.colors.group1.base
    }
  }
}));

export const DestinationItemLabelWrapper = styled.span(({ theme }: ThemeProps) => ({
  display: 'flex',
  flex: 1,
  justifyContent: 'space-between',
  paddingRight: theme.custom.spacing.medium
}));

export const FlagIcon: any = styled(CountryFlag)(({ theme }: ThemeProps) => ({
  marginTop: 4,
  marginRight: theme.custom.spacing.xSmall
}));

export const ViewAllTripTypeWrapper = styled.span(({ theme }: ThemeProps) => ({
  fontSize: theme.custom.fontSize.medium,
  marginTop: theme.custom.spacing.medium
}));
